module.exports = __webpack_public_path__ + "static/media/image.69eb438d.svg";